import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import FixedSection from "../../Components/FixedSection";
import { useParams } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { api } from "methods/api";
import { HardProductsType } from "types/HardProducts";
import { Category } from "types/Root";
import RenderRte from "Components/RenderRte";
import Spinner from "pages/SpinnerPage/Spinner";
import { imgPath } from "methods/img";
import "./main.css";
import { homeContext } from "pages/HomeContext";
import { LocalNavLink } from "hooks/useLocalNavigate";

function HurghadaCard() {
  const [t] = useTranslation();
  const { id } = useParams();
  const [status, setStatus] = useState<"none" | "loading" | "done">("none");
  const [products, setProducts] = useState<HardProductsType | undefined>(
    undefined
  );
  const [selectedId, setSelectedId] = useState<string | undefined>(id);
  const { homeData } = useContext(homeContext);
  const categoriesList: Category[] = homeData?.Categories ?? [];

  function getProductsData(categoryId?: string) {
    if (!categoryId) return;
    setStatus("loading");
    axios
      .get<{ data: HardProductsType }>(api(`products/${categoryId}`))
      .then(({ data }) => {
        setStatus("done");
        setProducts(data.data);
      })
      .catch((error) => {
        console.log("error", error);
        setStatus("none");
      });
  }

  // أول تحميل للصفحة - بياخد الـ id من الرابط
  useEffect(() => {
    getProductsData(id);
    setSelectedId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  function handleCategoryClick(categoryId: number) {
    const idStr = String(categoryId);
    setSelectedId(idStr);
    getProductsData(idStr);
  }

  return (
    <>
      {status == "done" ? (
        <>
          <FixedSection title={homeData?.siteInformation?.service_title} />
          <Stack sx={{ padding: "80px 30px" }}>
            <Container>
              <Grid container spacing={4}>
                {/* السايد بار - كل التصنيفات (فلتر، مش لينك) */}
                <Grid item xs={12} md={3}>
                  <Stack spacing={1.5}>
                    {categoriesList.map((cat) => {
                      const isActive = String(cat.id) === String(selectedId);
                      return (
                        <Box
                          key={cat.id}
                          onClick={() => handleCategoryClick(cat.id)}
                          sx={{
                            p: 2,
                            textAlign: "center",
                            borderRadius: "10px",
                            cursor: "pointer",
                            backgroundColor: isActive
                              ? "primary.main"
                              : "#f0f0f0",
                            color: isActive ? "#fff" : "text.primary",
                            fontWeight: 600,
                            transition: "all .3s",
                            "&:hover": {
                              backgroundColor:
                                homeData?.SiteColor?.secondaryColor ||
                                "#F19B02",
                              color: "#fff",
                            },
                          }}
                        >
                          {cat.title}
                        </Box>
                      );
                    })}
                  </Stack>
                </Grid>

                {/* المنتجات بتاعة التصنيف المختار */}
                <Grid item xs={12} md={9}>
                  <Typography variant="h4" sx={{ fontWeight: 600, mb: 4 }}>
                    {products?.category}
                  </Typography>

                  <Grid container spacing={2}>
                    {products?.products.map((card, index) => (
                      <Grid item md={6} key={index}>
                        <Card
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            minHeight: "630px",
                            backgroundColor: "#fff",
                            border: "2px solid",
                            borderRadius: "10px",
                            "&:hover .line": {
                              width: 1,
                            },
                          }}
                        >
                          <Stack sx={{ position: "relative" }}>
                            <Box
                              component={LocalNavLink}
                              to={`/project/${card.id}`}
                              sx={{
                                overflow: "hidden",
                                "&:hover img": {
                                  transform: "scale(1.1)",
                                  height: "250px",
                                },
                              }}
                            >
                              <img
                                src={imgPath(card.images[0].image)}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  transition: "all .5s",
                                }}
                                alt=""
                              />
                            </Box>
                            <Typography
                              variant="h6"
                              sx={{
                                backgroundColor: "primary.main",
                                color: "#fff",
                                textAlign: "center",
                                position: "absolute",
                                bottom: "0",
                                left: "50%",
                                fontWeight: "700",
                                p: "3px 12px",
                                transform: "translateY(50%) translateX(-50%)",
                                borderRadius: "10px",
                              }}
                            >
                              {card.price}
                            </Typography>
                          </Stack>

                          <CardContent>
                            <Typography
                              variant="h6"
                              component={LocalNavLink}
                              to={`/project/${card.id}`}
                              sx={{
                                fontWeight: 700,
                                marginTop: 4,
                                marginBottom: 2,
                                display: "inline-block",
                              }}
                            >
                              {card.title}
                            </Typography>
                            <Box
                              color={"#F19B02"}
                              sx={{
                                borderBottom: "dashed 1px #000",
                                pb: 2,
                              }}
                            >
                              <StarIcon />
                              <StarIcon />
                              <StarIcon />
                              <StarIcon />
                              <StarIcon />
                            </Box>
                            <Typography
                              className="limit_word"
                              variant="body1"
                              sx={{ py: 2 }}
                            >
                              <RenderRte rte={card.description} more={true} />
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                variant="body1"
                                component={LocalNavLink}
                                sx={{
                                  borderRadius: "10px",
                                  backgroundColor:
                                    homeData?.SiteColor.mainColor,
                                  transition: "all .3s",
                                  color: "#fff",
                                  padding: "9px",
                                }}
                                to={`/project/${card.id}`}
                              >
                                {t("main.ReadMore")}
                              </Typography>
                            </Box>
                          </CardContent>
                          <Box
                            sx={{
                              width: 0,
                              height: "5px",
                              backgroundColor: homeData?.SiteColor.mainColor,
                              transition: "all .8s",
                            }}
                            className={"line"}
                          ></Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </Stack>
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
}

export default HurghadaCard;